// // Initialize the Gantt chart
import Gantt from '../Gantt/src/index.js';
import {escapeHtml} from './utils/escapeHtml.js';
let loss_run_gantt_graff;


function formatDate(dateString) {
	const [year, month, day] = dateString.split('-');
	return `${month}/${day}/${year.slice(-2)}`;
}
export function loss_run_gantt_graff_init() {
	// Define the date range
	const startDate = new Date();
	const endDate = new Date();

	let $loss_run_gantt_graff_element = document.querySelector('#loss_run_gantt_graff');
	if (!$loss_run_gantt_graff_element) return;

	loss_run_gantt_graff = new Gantt($loss_run_gantt_graff_element, [
		{
			id: 'start-placeholder',
			name: '234',
			start: `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`,
			end: `${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`,
			progress: 0,
			dependencies: '',
			custom_class: 'placeholder-task',
		},
	], {
		header_height: 50,
		column_width: 0,
		// step: 50,
		view_modes: ['Quarter Day', 'Half Day', 'Day', 'Week', 'Month'],
		bar_height: 50,
		bar_corner_radius: 0,
		arrow_curve: 0,
		padding: 0,
		view_mode: 'Year',
		date_format: 'YYYY-MM-DD',
		language: 'en',
		show_popup_trigger: 'pointerover',
		hide_popup_trigger: 'pointerout',
		custom_popup_html: function (task) {
			if (task?.task_data?.loss_run == null) return;

			this.parent.setAttribute('id', 'loss_run_gantt-popup-wrapper');

			let loss_run = task?.task_data?.loss_run;

			let loss_run_report_row_html = `<p><b>No LR Report</b></p>`;
			if (task?.task_data?.loss_run_report != null) {
				let loss_run_report = task.task_data.loss_run_report;
				loss_run_report_row_html = `<p><b>LR Report:</b> ${loss_run_report.covered_start_date ? escapeHtml(formatDate(loss_run_report.covered_start_date)) : '[no date]'} - ${loss_run_report.covered_end_date ? escapeHtml(formatDate(loss_run_report.covered_end_date)) : '[no date]'}</p>`;
			}

			let allowance_gap_html = '';
			if(loss_run.allowance == 1){
				allowance_gap_html = '<p><b>30-Day Allowance:</b> ' + loss_run.allowance_gap + '</p>';
			}


			return `<div class="popup_html ${escapeHtml(loss_run.status)} ${escapeHtml(+loss_run.invalid ? 'Invalid' : 'Valid')}">
						<h5>Policy Term: ${escapeHtml(loss_run.policy_start_date)} - ${escapeHtml(loss_run.policy_end_date)}</h5>
						<p>${escapeHtml(loss_run.insurance_company)}</p>
						<p>#${escapeHtml(loss_run.policy_number)}</p>
						<p><b>Run Date:</b> ${loss_run.run_date}</p>						
						${allowance_gap_html}
						${loss_run_report_row_html}
				 		<p>${escapeHtml(loss_run.qty_of_claims)} / $${escapeHtml(loss_run.loss_dollar)}</p>
					</div>`;
		},
	});
	loss_run_gantt_graff.$container.setAttribute('id', 'loss_run_gantt_graff_wrapper');
	// setInterval(()=>{loss_run_gantt_graff_layout()}, 1000)

}

export function loss_run_gantt_graff_update_data({loss_run_report_array, loss_run_array, period_array} = {}) {
	if (!loss_run_gantt_graff) {
		console.error('no loss_run_gantt_graff');
		return;
	}

	// --- NEW CHECK to clear old data if there's no fresh policy info ---
	if (!Array.isArray(loss_run_array) || !loss_run_array.length) {
		console.info('No policy data found, clearing Gantt...');
		$('#loss_run_gantt_graff_wrapper').hide();
		return;
	}
	$('#loss_run_gantt_graff_wrapper').show();
	let tasks = loss_run_gantt_graff.tasks;
	if (loss_run_array == null) {
		console.error('no data');
	} else {
		tasks = [];
		loss_run_array.forEach((loss_run) => {

			let custom_class = `${escapeHtml(+loss_run.invalid ? 'Invalid' : 'Valid')}`;
			if (loss_run.allowance == 1) {
				custom_class += ' policy_terms';
			} else {
				custom_class += ' no_report no_report1';
			}
			let policy_start_date_sql_Y_m_d = loss_run.policy_start_date_sql_Y_m_d;
			if (policy_start_date_sql_Y_m_d === '0000-00-00') {
				policy_start_date_sql_Y_m_d = null;
			}
			let policy_end_date_sql_Y_m_d = loss_run.policy_end_date_sql_Y_m_d;
			if (policy_end_date_sql_Y_m_d === '0000-00-00') {
				policy_end_date_sql_Y_m_d = null;
			}


			let task_name = '';

			let policy_number_html = '';
			if (loss_run.policy_number == null) {
				policy_number_html = '[no policy number]';
			} else if (String(loss_run.policy_number).trim() === '') {
				policy_number_html = '[no policy number]';
			} else {
				policy_number_html = `#${escapeHtml(loss_run.policy_number)}`;
			}
			if (policy_start_date_sql_Y_m_d != null && policy_end_date_sql_Y_m_d != null) {
				task_name = `<tspan class="bold">${policy_number_html}</tspan> ${escapeHtml(loss_run.policy_start_date)} - ${escapeHtml(loss_run.policy_end_date)}`;
			} else {
				task_name = `<tspan class="bold">${policy_number_html}</tspan>`;
			}
			let task = {
				id: `loss_run_gantt_graff-${escapeHtml(loss_run.id)}`,
				name: task_name,
				start: policy_start_date_sql_Y_m_d,
				end: policy_end_date_sql_Y_m_d,
				progress: null,
				dependencies: '',
				custom_class: custom_class,
			};


			report_covered_block: {
				if (loss_run.report_covered_start_date == null || loss_run.report_covered_end_date == null) {
					task.custom_class += ' no_report no_report2';

					break report_covered_block;
				}

				// Initialize subtasks array
				let subtasks = [];


				let policy_start_date_time = new Date(policy_start_date_sql_Y_m_d).getTime();

				let policy_end_date_time = new Date(policy_end_date_sql_Y_m_d).getTime();
				{


					for (let i = 0; i < loss_run_report_array.length; i++) {
						let loss_run_report = loss_run_report_array[i];


						let report_covered_start_time = new Date(loss_run_report.covered_start_date).getTime();

						let report_covered_end_time = new Date(loss_run_report.covered_end_date).getTime();

						if (report_covered_end_time <= policy_start_date_time) {
							continue;
						}
						if (report_covered_start_time > policy_end_date_time) {
							continue;
						}

						let fill_start = loss_run_report.covered_start_date;
						let fill_end = loss_run_report.covered_end_date;

						if (report_covered_start_time <= policy_start_date_time) {
							fill_start = policy_start_date_sql_Y_m_d;
						}
						if (report_covered_end_time >= policy_end_date_time) {
							fill_end = policy_end_date_sql_Y_m_d;
						}
						// let run_date_grace = run_date + '+1 mounth'//30 * 24
						//
						// let fill_end_time = new Date(fill_end).getTime();
						// if (fill_end_time > run_date_grace) {
						// 	fill_end = run_date_grace;
						//
						//
						// }


						let subtask = {
							id: `loss_run_gantt_graff-${loss_run.id}:${subtasks.length}`,
							name: '',
							start: fill_start,
							end: fill_end,
							progress: null,
							dependencies: '',
							custom_class: `${escapeHtml(+loss_run.invalid ? 'Invalid' : 'Valid')}`,
						};

						subtask.custom_class += ' inside_report_covered';

						subtask.task_data = {
							loss_run,
							loss_run_report,
						};
						subtasks.push(subtask);

						if (loss_run.allowance == 1) {

							// Subtask Part 2: From run_date to allowance_date with 'no_report' class

							let subtask_gap = {
								id: `loss_run_gantt_graff-${loss_run.id}:${subtasks.length}`,
								name: '',
								start: loss_run_report.report_run_date,
								end: getCurrentDateYMD(), // today's date
								progress: null,
								dependencies: '',
								custom_class: `${escapeHtml(+loss_run.invalid ? 'Invalid' : 'Valid')}`,
							};

							if (loss_run.allowance_gap_days < 0) {
								subtask_gap.custom_class += ' no_report';
							} else {
								subtask_gap.custom_class += ' inside_report_covered allowance_gap_positive';
							}

							subtask_gap.task_data = {
								loss_run,
								loss_run_report,
							};
							subtasks.push(subtask_gap);

						}
					}


				}

				// task = {
				// 	id: `report_covered__loss_run_gantt_graff-${loss_run.id}`,
				// 	name: task_name,
				// 	start: loss_run.report_covered_start_date,
				// 	end: loss_run.report_covered_end_date,
				// 	progress: null,
				// 	dependencies: '',
				// 	custom_class: `${escapeHtml(+loss_run.invalid ? 'Invalid' : 'Valid')} report_covered`,
				// };
				task.subtasks = subtasks;

			}


			task.task_data = {
				loss_run,
			};

			tasks.push(task);
			return;

		});
	}

	// Define tasks

	let lines = loss_run_gantt_graff.lines;

	if (period_array == null) {
		console.error('no data');
	} else {
		lines = period_array.map((period) => {
			return {
				start: period.policy_end_date,
			};
		});
		if (period_array.length) {
			let last_period = period_array[period_array.length - 1];
			lines.push({
				start: last_period.policy_start_date,
			});
		}
	}

	loss_run_gantt_graff.refresh(tasks, {lines});
}

export function loss_run_gantt_graff_layout() {
	if (!loss_run_gantt_graff) {
		console.error('no loss_run_gantt_graff');
		return;
	}
	loss_run_gantt_graff.render();
}
function getCurrentDateYMD() {
	const today = new Date();
	const yyyy = today.getFullYear();
	const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
	const dd = String(today.getDate()).padStart(2, '0');
	return `${yyyy}-${mm}-${dd}`;
}
